import React from 'react';
import { useDispatch } from 'react-redux';
import { Flex, Box } from 'rebass/styled-components';
import { SidebarClose } from 'lucide-react';
import { toggleMenu } from '../../../features/mainMenu';
import { NetworkOption } from '../NetworkOption';

export const NavHeader = () => {
  const dispatch = useDispatch();

  return (
    <Flex
      px="8px"
      py="12px"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        gap: '4px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <NetworkOption />
      <Flex
        className="main-menu-close-icon"
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        sx={{ cursor: 'pointer' }}
        onClick={() => dispatch(toggleMenu())}
      >
        <Box
          as={SidebarClose}
          className="main-menu-item"
          width="16px"
          height="16px"
          aria-hidden="true"
          flex="0 0 auto"
        />
      </Flex>
    </Flex>
  );
};
